<template>
  <div style="width: 100%">
    <div style="height:45px">
      <v-btn class="refresh-button" @click="getOrdersForAllStages(userId)"><v-icon color="#6E6E6E">mdi-sync</v-icon></v-btn>
    </div>
    <v-data-table
      class="table-style"
      :headers="headers"
      :items="devOrders"
      single-select
      item-key="orderId"
      :sort-by="['date']"
      :sort-desc="[false]"
      show-select
      hide-default-footer
      show-expand
      single-expand
      :expanded.sync="expanded"
      :loading="devDataLoading"
      :custom-sort="customSort">
      <template v-slot:item.data-table-select="props">
        <v-radio-group v-model="selectedDevOrder">
          <v-radio :value="props.item.orderId"></v-radio>
        </v-radio-group>
      </template>
      <template v-slot:[`item.date`]="{ item }">
        <span>{{ item.date | dateFormat('DD.MM.YYYY') }}</span>
      </template>
      <template v-slot:[`item.address`]="{ item }">
        <div v-html="item.address"> </div>
      </template> 
      <template v-slot:item.note="props">
        <v-edit-dialog
          :return-value.sync="props.item.note"
          @save="saveNoteToDev({orderId: props.item.orderId, note: props.item.note})"
        > {{ props.item.note }}
          <template v-slot:input>
            <v-text-field
              v-model="props.item.note"
              label="Edit"
              single-line
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length"> <pre>{{item.json}}</pre></td>
      </template>
    </v-data-table>
    <div>
      <template-actions @downloadPdf="downloadPdf"
                        @downloadEmailPreview="downloadEmailPreview"
                        @sendEmail="sendEmail"
                        @selected="foo"/>
    </div>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{statusText}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="text-center ma-2">
        <v-snackbar v-model="snackbar">
          {{ text }} 
          <v-btn @click="snackbar = false" fab color="primary">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-snackbar>
    </div>
  </div>
</template>

<script>
  import TemplateActions from "./TemplateActions";
  import {
    getUserDocumentGraphQL,
    triggerSendEmail,
    uploadOrderNoteToDev,
    uploadOrderNoteToTest
  } from "../../services/UserService";
  import { getMockOrders } from '../../services/OrderService';

  export default {
    name: "TemplatesComponent",
    components: {
      TemplateActions,
    },
    created() {
      // eslint-disable-next-line no-undef
      if(loginNew.isSignedIn()) {
        // eslint-disable-next-line no-undef
        const profile = loginNew.getProfile();      
        if(profile) {
          this.userId = profile["sub"];
          this.getOrdersForAllStages(this.userId);
        }
      } else {
      // eslint-disable-next-line no-undef
      loginNew.onAuthStateChanged((event) => {
        if(!event.detail.selfExecuted){
          // eslint-disable-next-line no-undef
          const profile = loginNew.getProfile();      
          if(profile) {
            this.userId = profile["sub"];
            this.getOrdersForAllStages(this.userId);
          }
        }
      })
      }
    },
    data() {
      return {
        expanded: [],
        snackbar: false,
        text: 'Bitte Bestellung und Template auswählen',
        userId: '',
        testExpanded: [],
        prodExpanded: [],
        statusText: '',
        activeClass: 'tab-active',
        selectedDevOrder: '',
        selectedTestOrder: '',
        selectedProdOrder: '',
        dialog: false,
        selectedTemplates: [],
        devDataLoading: true,
        testDataLoading: true,
        prodDataLoading: true,
        headers: [
          {
            text: 'Date',
            align: 'start',
            sortable: true,
            value: 'date',
          },
          { text: 'Produkt', value: 'product' , width: '350px'},
          { text: 'Besteller', value: 'customer', width: '200px'},
          { text: 'Anschlussadresse', value: 'address', width: '200px'},
          { text: 'Notiz', value: 'note'},
          { text: '', value: 'data-table-expand' },
        ],
        headersProd: [
          {
            text: 'Date',
            align: 'start',
            sortable: true,
            value: 'date',
          },
          { text: 'Produkt', value: 'product' },
          { text: 'Besteller', value: 'customer'},
          { text: 'Anschlussadresse', value: 'address'},
          { text: '', value: 'data-table-expand' },
        ]
      }
    },
    computed: {
      selectedTab: {
        get() {
          return this.$store.getters.getSelectedTab;
        },
        set(newValue) {
          this.$store.commit('setSelectedTab', newValue);
        }
      },
      testOrders() {
        return this.$store.getters.getPresentableTestOrders;
      },
      devOrders() {
        return this.$store.getters.getPresentableOrders;
      } ,
      prodOrders() {
        return this.$store.getters.getPresentableProdOrders;
      },
      stage() {
        if(this.selectedTab === 0) {
          return 'dev';
        } else if(this.selectedTab === 1){
          return 'test';
        } else {
          return 'prod';
        }
      },
      orderId() {
        if(this.stage === 'dev') {
          return this.selectedDevOrder;
        } else if (this.stage === 'test') {
          return  this.selectedTestOrder;
        } else {
          return this.selectedProdOrder
        }
      }
    },
    methods: {
      getOrdersForAllStages(){
        getMockOrders().then(orders => {
          this.$store.commit('setOrders', orders);
          this.devDataLoading = false;
        }).catch(err => {
          console.log(err);
        })        
      },
      customSort: function(items, index, isDesc) {
        items.sort((a, b) => {
            if (index[0]=='date') {
              if (!isDesc[0]) {
                  return b[index] - a[index];
              } else {
                  return a[index] - b[index];
              }
            }
            else {
              if(typeof a[index] !== 'undefined'){
                if (!isDesc[0]) {
                  return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
                }
                else {
                    return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
                }
              }
            }
        });
        return items;
      },
      foo(event) {
        this.selectedTemplates = event;
      },
      sendEmail() {
        this.statusText = 'Email wird versendet...';
        let allProms = [];

        if(this.orderId && this.selectedTemplates.length > 0) {
          this.dialog = true;
          for(const selectedTemplate of this.selectedTemplates) {
            const fileName = `${selectedTemplate}.html`

            const prom = triggerSendEmail(this.orderId, fileName, this.stage);
            allProms.push(prom);
          }

          Promise.all(allProms).then(() => {
            // Do something with result if you need to
          }).catch(err => {
            console.log(err);
          }).finally(() => {
            this.dialog = false;
          });

        } else {
          this.snackbar = true;
        }
      },
      saveNoteToDev({orderId, note}) {
        // eslint-disable-next-line no-undef
        const profile = loginNew.getProfile();
        const userId = profile["sub"];
        uploadOrderNoteToDev(userId, orderId, note).then(res => {
          console.log(res);
        }).catch(err => {
          console.log(err);
        })
      },
      saveNoteToTest({orderId, note}) {
        // eslint-disable-next-line no-undef
        const profile = loginNew.getProfile();
        const userId = profile["sub"];
        uploadOrderNoteToTest(userId, orderId, note).then(res => {
          console.log(res);
        }).catch(err => {
          console.log(err);
        })
      },
      downloadPdf() {
        this.statusText = 'Dateien werden runtergeladen...';
        let orderId = this.selectedDevOrder;
        let stage = 'dev';
        let promises = [];


        switch (this.selectedTab) {
          case 1:
            orderId = this.selectedTestOrder;
            stage = 'test'
            break;
          case 2:
            orderId = this.selectedProdOrder;
            stage = 'prod'            
            break;     
        }

        if(orderId && this.selectedTemplates.length > 0) {
          this.dialog = true
          for(const template of this.selectedTemplates) {
            console.log(`orderid: ${orderId} template: ${template} stage: ${stage}`, "downloadPdf")
            const foo = getUserDocumentGraphQL(`${orderId}/${template}.html`, stage);
            promises.push(foo);
          }

          Promise.all(promises).then(res => {
            for(const template in this.selectedTemplates) {
              const templateName = this.selectedTemplates[template];
              let signedURL = res[template].data.data.downloadFile;
              this.downloadFIleFromSignedURL(signedURL, `${templateName}.pdf`);
            }
          }).catch(err => {
            console.log(err);
          }).finally(() => {
            this.dialog = false;
          });
        } else {
          this.snackbar = true;
        }
      },
      convertResponseEncodeing(templateBlob) {
        const byteCharacters = atob(templateBlob)
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return byteArray
      },
      downloadEmailPreview() {
        this.statusText = 'Dateien werden runtergeladen...';
        let orderId = this.selectedDevOrder;
        let promises = [];
        let stage = 'dev';

        switch (this.selectedTab) {
          case 1:
            orderId = this.selectedTestOrder;
            stage = 'test'
            break;
          case 2:
            orderId = this.selectedProdOrder;
            stage = 'prod'            
            break;     
        }

        if(orderId && this.selectedTemplates.length > 0) {
          this.dialog = true
          for(const template of this.selectedTemplates) {
            const foo = getUserDocumentGraphQL(`${orderId}/${template}.html`, stage);
            promises.push(foo);
          }
          console.log(promises)
          Promise.all(promises).then(res => {
            for(const template in this.selectedTemplates) {
              const templateName = this.selectedTemplates[template];
              let signedURL = res[template].data.data.downloadFile;
              this.downloadFIleFromSignedURL(signedURL, `${templateName}.html`);
            }
          }).catch(err => {
            console.log(err);
          }).finally(() => {
            this.dialog = false;
          })
        } else {
          this.snackbar = true;
        }
      },
      downloadFIleFromSignedURL( fileURL , fileName) {
        const fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
      },
    },
  }
</script>

<style lang="scss" scoped>
  $main-color: #FFFFFF;
  .tab-font {
    text-align: left;
    font-size: 16px;
    line-height: 18px;
    letter-spacing: 0;
    color: #6E6E6E;
    opacity: 1;
  }

  .tab-style {
    color: #6E6E6E;
    text-transform: none !important;
    margin-bottom: 1px;
    background-color: $main-color;
    opacity: 0.7;
  }

  .tab-active {
    background-color: $main-color;
    margin-bottom: 0;
    opacity: 0.9;
  }

  .tab-item-style {
    background-color: $main-color;
    opacity: 0.9;
  }

  .round-top-right-corner {
    border-radius: 0 12px 0 0;
  }

  .round-top-left-corner {
    border-radius: 12px 0 0 0;
  }
  .table-style {
    background-color: $main-color;
    opacity: 0.9;
  }

  pre {
    white-space: pre-wrap;       /* Since CSS 2.1 */
    white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
    white-space: -pre-wrap;      /* Opera 4-6 */
    white-space: -o-pre-wrap;    /* Opera 7 */
    word-wrap: break-word;       /* Internet Explorer 5.5+ */
}
  .refresh-button {
    border-radius: 12px 12px 0 0;
    position: absolute; 
    right: 0;
    background-color: #FFFFFF;
    margin-bottom: 0;
    opacity: 0.9;
    height: 45px !important;
    width: 90px;
    margin-right: 25px;
  }
</style>
